export const EMPTY_BAAS_STABLES_WALLET_LIST_FILTERS = {
  network: "all",
  status: "all",
  asset: "all",
  entity: "all",
  searchQuery: "",
};

export const filterBaasStablesWallets = (
  wallets = [],
  filters = EMPTY_BAAS_STABLES_WALLET_LIST_FILTERS,
) => {
  let items = [...wallets];

  if (filters.network && filters.network !== "all") {
    items = items.filter((item) => item.network === filters.network);
  }

  if (filters.status && filters.status !== "all") {
    items = items.filter((item) => item.status === filters.status);
  }

  if (filters.asset && filters.asset !== "all") {
    items = items.filter((item) => item.asset === filters.asset);
  }

  if (filters.entity && filters.entity !== "all") {
    items = items.filter((item) => item.entityId === filters.entity);
  }

  const query = String(filters.searchQuery || "").trim().toLowerCase();
  if (query) {
    items = items.filter(
      (item) =>
        item.alias?.toLowerCase().includes(query) ||
        item.address?.toLowerCase().includes(query) ||
        item.asset?.toLowerCase().includes(query) ||
        item.entityName?.toLowerCase().includes(query) ||
        item.accountAlias?.toLowerCase().includes(query) ||
        item.accountNumber?.toLowerCase().includes(query),
    );
  }

  return items;
};
